import React, { useContext, useEffect, useState } from "react";
import DriveContext from "./context/driveContext";
import convertS3ToCloudFront from "../../../../utils/convertS3ToCloudFront";
import { Row, Col, Modal, notification, Input, Button } from "antd";
import { FaArrowLeft } from "react-icons/fa";
import { ImImages } from "react-icons/im";
import { IoMdMore } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";

const Main = () => {
  const {
    currentPage,
    apiBaseUrl,
    getAlbums,
    albums,
    setAlbums,
    setCurrentPage,
    selectedAlbum,
    setSelectedAlbum,
    albumName,
    setAlbumName,
    UploadZip,
  } = useContext(DriveContext);
  console.log(apiBaseUrl);
  const [coverPage, setCoverPage] = useState("");
  const [createAlbumModal, setCreateAlbumModal] = useState(false);
  const [newAlbumData, setNewAlbumData] = useState({});
  const [isUploading, setIsUploading] = useState(false);
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setIsUploading(true);

    try {
      const uploadResponse = await UploadZip(file.name, file.type);
      if (uploadResponse && uploadResponse.data) {
        const formData = new FormData();
        Object.keys(uploadResponse.data.fields).forEach((key) => {
          formData.append(key, uploadResponse.data.fields[key]);
        });
        formData.append("file", file);
        await fetch(uploadResponse.data.url, {
          method: "POST",
          body: formData,
        });
        handleDataChange(
          "coverPage",
          convertS3ToCloudFront(
            `${uploadResponse.data.url}/${uploadResponse.data.fields.key}`,
          ),
        );

        // notification.success({ message: 'Client logo uploaded successfully' });
      }
    } catch (error) {
      console.error("File upload error:", error);
      notification.error({ message: "Failed to upload client logo" });
    } finally {
      setIsUploading(false);
    }
  };
  useEffect(() => {
    getAlbums();
  }, []);
  const createAlbum = async () => {
    const requestBody = {
      subClientId: "679c9bb884bec91cef4b8758",
      albumData: {
        coverPage: "https://s3.ap-south-1.amazonaws.com/prepseed/prod/ldoc/media/Yellow%20spot%20pc%20wallpaper.jpg",
        title: newAlbumData?.title,
        media: [],
      },
    };
    try {
      const response = await fetch(
        `${apiBaseUrl}/mediaAgencyRouter/createNewAlbum`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(requestBody),
        }
      );
      const data = await response.json();
      // console.log(data);
      if (data.success) {
        getAlbums();
        setNewAlbumData({});
        setCreateAlbumModal(false);
        notification.success({ message: data.message });
      }
    } catch (err) {
      console.error(err);
    }
  };
  const handleDataChange = (key, value) => {
    setNewAlbumData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  return (
    <div
      className="parent-padding-container"
      style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "center",
        }}
      >
        <h4 style={{ fontSize: "20px" }}>Drive</h4>
        <Button
          type="primary"
          onClick={() => {
            setCreateAlbumModal(true);
          }}
        >
          + Add New Folder
        </Button>
      </div>
      <div style={{width:"100%"}}>
        <div className="ContainerBody">
          <div className="ContainerBodyContainer">
            <div id="MediaAlbumsCards">
              <Row>
                {albums?.map((item, index) => (
                  <Col key={index} lg={6} md={8} style={{ width: "100%" }}>
                    <div
                      className="MediaClientCard"
                      onClick={() => {
                        setCurrentPage("mediaPage");
                        setSelectedAlbum(item);
                      }}
                    >
                      <div className="CardTitle">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <ImImages />
                          <h6 style={{ margin: "0px", paddingLeft: "10px" }}>
                            {item?.title}
                          </h6>
                        </div>
                        <div>
                          <IoMdMore />
                        </div>
                      </div>
                      <div
                        className="CardImage"
                        style={{ height: "100%", overflow: "hidden" }}
                      >
                        <img
                          src={item?.coverPage}
                          alt="Album Cover Page"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={createAlbumModal}
        onCancel={() => {
          setNewAlbumData({});
          setCreateAlbumModal(false);
        }}
        onOk={createAlbum}
        title="Create Album"
      >
        <div className="FormContainer">
          <div className="FormLableInput">
            <label htmlFor="">Album Name</label>
            <Input
              placeholder="Enter Album name"
              onChange={(e) => {
                handleDataChange("title", e.target.value);
              }}
            />
          </div>
          {/* <div className="FormLableInput">
            <label htmlFor="">Upload Client Logo</label>
            <input
              type="file"
              accept="image/*" // This restricts the input to image files only
              onChange={handleFileUpload}
              disabled={isUploading}
            />
          </div>
          <div className="FormLabelInput">
            {newAlbumData.coverPage && (
              <img
                src={newAlbumData.coverPage}
                alt="Album Cover page"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            )}
          </div> */}
        </div>
      </Modal>
    </div>
  );
};

export default Main;
